import { render, staticRenderFns } from "./composantAdminAsso.vue?vue&type=template&id=036607ae&scoped=true"
import script from "./composantAdminAsso.vue?vue&type=script&lang=js"
export * from "./composantAdminAsso.vue?vue&type=script&lang=js"
import style0 from "./composantAdminAsso.vue?vue&type=style&index=0&id=036607ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036607ae",
  null
  
)

export default component.exports